import Sconti from '../../views/orders/Sconti';
import History from '../../views/orders/History';
import Details from '../../views/orders/Details';
import Options from '../../views/orders/Options';
import Summary from '../../views/orders/Summary';

export default [
    {
        path: '/ordine',
        name: 'orders',
        component: Options,
        meta: {showNav: true}
    },
    {
        path: '/ordine/sconti',
        name: 'orders.discounts',
        component: Sconti,
        meta: {showNav: true}
    },
    {
        path: '/ordine/storico',
        name: 'orders.history',
        component: History,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/ordine/dettaglio/:id',
        name: 'orders.details',
        component: Details,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/ordine/riepilogo/:id',
        name: 'orders.summary',
        component: Summary,
        meta: {showNav: true}
    },
]
